<template>
    <div class="seeTuiguangQrcodeCont">
       <van-nav-bar
        title="推广物料"
        left-arrow
        @click-left="
            backPreHandle()
        "
        />
        <div class="shareTipsCont" :class="{ showShareTipsIcon: isShowShareTip }"> </div>

        <div class="qrcodeInforCont">
            <p class="qrcodeInforTitle">商品名称：{{listData && listData.goodsName}}</p>
            <div id="qrcode" class="code qrcodeImg" ref="qrCodeDiv" v-show="firstFlag"></div>

            <div v-show="!firstFlag">
                <img class="qrcodeImg" :src="canvasImageUrl"/>
            </div>            
            <!-- <img class="qrcodeImg" :src="listData && listData.picUrl"/> -->
            <p class="changanTips">长按二维码保存并分享</p>
            <div class="qrcodeTipNav" v-if="false">
                <div class="qrcodeTipNavFooterNav" @click="clickShareHandle()" v-if="false">
                    <img src="../../../assets/images/agentManage/wechart_icon_new.png"/>
                    <p>分享到微信</p>
                </div>
                <div class="qrcodeTipNavFooterNav needCopyBtn" @click="copyliveUrl()">
                    <img src="../../../assets/images/agentManage/copyLink_icon_new.png"/>
                    <p>复制链接</p>
                </div>

            </div>
        </div>

     </div>
</template>

<script>
import Vue from 'vue'
import  'weixin-js-sdk'
import { Toast } from 'vant';
import Clipboard from 'clipboard';
import html2canvas from 'html2canvas'
import QRCode from 'qrcodejs2'

export default {
    name: "seeTuiguangQrcode",
    data () {
        return {
            isShowShareTip: false,
            copyUrl: '',
            code: '',
            wxToken: '',
            listData: null,

            firstFlag: true,
            canvasImageUrl: ""

        };
    },
    components: {
        
    },

    computed: {
    },


    created(){
       
       
        
        

    },

    mounted(){
        this.getQrCode();
        
        
        // if (this.WeiXin()) {
        //     //是微信
        //     this.code = this.getUrlCode("code"); // 获取code  是否有值  否则返回null
        //     console.log("this.code", this.code);
        //     this.userExistOpenId(); // 判断用户是否有opneid
        //     if (this.$route.query.iswx) {
        //         this.show = true; // 显示弹窗
        //         // this.getOrderStatus(); // 手机自带返回按键返回判断是否支付成功；
        //     //     //检查是否返回iswx 字段，从微信路由正常跳转返回iswx
        //     //         // this.cashierLaunchPay(); //调用支付方式
        //         }

        // }

       
    },
    destroyed(){
        
    },

    methods: {
        clickShareHandle() {
            this.isShowShareTip = true;
        },
        backPreHandle() {
            this.$router.go(-1);
        },


        copyliveUrl() {
            let txt = this.copyUrl
            console.log('this.copyUrl====',txt)
            let clipboard = new Clipboard('.needCopyBtn', {
                text: function () {
                    return txt;
                }
            })
            clipboard.on('success', e => {
                Toast({
                    message: '复制成功',
                    duration: 1000,
                });
                console.log('复制 成功')
                // 释放内存
                clipboard.destroy();
            })
            clipboard.on('error', e => {
                Toast({
                    message: '复制失败',
                    duration: 1000,
                });
                clipboard.destroy();
            })
        },


        userExistOpenId () {
            // 判断用户是否有openId
            this.$api.home.userExistOpenId().then(res => {
                console.log('授权', res)
                if (!res.data) {
                // ture 不用获取code false 获取code
                this.getCode()
                } else {
                this.wxToken = true
                }
            })
        },


        getCode () {
        // 非静默授权，第一次有弹框
        // 截取code
        let that = this
        var local = window.location.href // 获取页面url
        var appid = 'wx35dc35dc7614928d'    //wx74589d074449de0e  encodeURIComponent
        if (this.code === null || this.code === '') {
            // 如果没有code，则去请求
            console.log('code===', this.code)
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx35dc35dc7614928d&redirect_uri=${
          local
        }&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
        } else {
            that.findWebAccessToken(that.code)
            // 你自己的业务逻辑
        }
        },
        findWebAccessToken (name) {
            // 微信授权是否成功  获取openid
            this.$api.home.findWebAccessToken(name).then(res => {
                console.log('this.wxToken', res)
                this.wxToken = res.data
                console.log(' this.wxToken', this.wxToken)

                window.wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
                    window.wx.updateTimelineShareData({ 
                        title: '分享代理商标题', // 分享标题
                        link: 'agent.fat.wdeduc.com', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: 'https://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/91e8b302360d4f32a6460b05fcf0d132-%E7%8C%B4%E5%AD%90.jpg', // 分享图标
                        success: function () {
                        // 设置成功
                         console.log('分享标题设置成功===')
                        }
                    })
                }); 


            })
        },



        WeiXin () {
            // 判断是否是微信内置浏览器
            let isWeiXin = () => {
                return (
                navigator.userAgent
                    .toLowerCase()
                    .indexOf('micromessenger') !== -1
                )
            }
            if (isWeiXin()) {
                return true
            } else {
                return false
            }
        },

        getUrlCode (name) {
            // 截取url中的code方法
            let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
            let r = window.location.search.substr(1).match(reg)
            if (r != null) return unescape(r[2])
            return null
        },      

        
        getQrCode(){        
            this.$api.agentManage.getQrCode(
                {
                    agentId: this.$route.query.agentId,
                    goodsId: this.$route.query.goodsId
                }
            )
            .then(res=>{
                if (res.data) {
                    this.listData = res.data
                    this.copyUrl = res.data.qrcode                
                    this.qrcode();
                    this.$nextTick(()=> {
                        this.createPicture(); // 二维码生成后，执行生成图片
                    });
                }      
            })
        },
            
        qrcode() {
            new QRCode(this.$refs.qrCodeDiv, {
                width: 145,
                height: 150,
                text: this.copyUrl, // 二维码地址
                // colorDark: "#000",// 二维码颜色
                // colorLight: "#fff"// 二维码背景色
            });
        },

        createPicture() {
            html2canvas(this.$refs.qrCodeDiv,
                {
                    width: 145,
                    height: 150
                }
            )
                .then(canvas => {
                    console.log('canvas===', canvas)
                    var imgData = canvas.toDataURL("image/jpeg");
                    console.log('imgData===', imgData)
                    this.canvasImageUrl = imgData;
                    this.firstFlag = false;
                }).catch(error => {});
        },
        
        
    
        
    },


}

</script>


<style  scoped>
 @import "../asset/css/agentManage.css";
</style>

